import { SxProps, TextField, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { UnitType } from '../../context/product_context'
import { currencyToNumber, maskCurrency } from '../../utils/maks'
import { useConfigs } from '../../context/configs_context'
import { useTranslation } from 'react-i18next'

interface Props {
    value: number
    setValue(v: number): void
    label: string
    unitType: string
    sx?: SxProps
    error?: string
    onClick?(): void
    size?: 'small' | 'medium'
    maxValue?: number
    id?: string
    fontSize?: string
    onKeyDown?(e: React.KeyboardEvent): void
}

export const UnitTypeField = ({
    value,
    setValue,
    label,
    sx,
    error,
    onClick,
    size,
    maxValue,
    unitType,
    id,
    fontSize = '16px',
    onKeyDown,
}: Props) => {
    const { t } = useTranslation()
    const { configs } = useConfigs()
    const [localValue, setLocalValue] = useState('')

    useEffect(() => {
        setLocalValue(
            maskCurrency(
                value,
                undefined,
                unitType === UnitType.Unit ? 0 : configs.qntDecimals
            )
        )
    }, [value, unitType])

    return (
        <TextField
            sx={{
                ...sx,
            }}
            error={Boolean(error)}
            helperText={error}
            onClick={onClick}
            value={localValue}
            label={t(label)}
            onChange={(e) => {
                let newValue = e.target.value.replace(/\D/g, '')
                let numberValue

                if (unitType === UnitType.Unit) {
                    numberValue = Number(newValue)
                } else {
                    numberValue =
                        Number(newValue) / Math.pow(10, configs.qntDecimals)
                }

                if (typeof maxValue === 'number' && numberValue > maxValue) return
                if (value === numberValue) return
                setValue(numberValue)
            }}
            onKeyDown={onKeyDown}
            InputProps={{
                id: id,
                endAdornment: (
                    <Typography
                        sx={{
                            mr: '2px',
                            whiteSpace: 'nowrap',
                            fontSize: fontSize,
                        }}
                    >
                        {unitType}
                    </Typography>
                ),
                style: {
                    fontSize: fontSize
                }
            }}
            size={size}
        />
    )
}
